/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * What the Assign Policies page asked for. `override` pins the given policies to the selected composites as a manual assignment; `resetToDefault` drops whatever is assigned and re-resolves the selection against the company's exception list.
 */
export enum CompositePolicyAssignmentAction {
    OVERRIDE = 'override',
    RESET_TO_DEFAULT = 'resetToDefault',
}
